// src/services/kioskFetch.ts
import { clearKioskToken, getKioskToken } from './kioskAuthService';

const API_BASE = process.env.REACT_APP_IMS_API_BASE_URL || 'http://localhost:4001';

function isAbsoluteUrl(u: string) {
  return /^https?:\/\//i.test(u);
}

export async function kioskFetch(
  endpointOrUrl: string,
  init: RequestInit = {},
  opts: { retryOn401?: boolean } = {}
) {
  const retryOn401 = opts.retryOn401 !== false;
  const url = isAbsoluteUrl(endpointOrUrl) ? endpointOrUrl : `${API_BASE}${endpointOrUrl}`;

  const token = await getKioskToken(false);

  const headers: Record<string, string> = {
    ...(init.headers as any),
    Authorization: `Bearer ${token}`,
  };

  if (!headers['Content-Type'] && init.body) headers['Content-Type'] = 'application/json';

  const res = await fetch(url, { ...init, headers });

  if (res.status === 401 && retryOn401) {
    clearKioskToken();
    const token2 = await getKioskToken(true);

    const headers2: Record<string, string> = {
      ...(init.headers as any),
      Authorization: `Bearer ${token2}`,
    };
    if (!headers2['Content-Type'] && init.body) headers2['Content-Type'] = 'application/json';

    return fetch(url, { ...init, headers: headers2 });
  }

  return res;
}
